import { CareerApplicationsListQuery } from 'core/graphql';

/** Статусы отклика — замкнутое объединение (см. комментарий к этапам). */
export type CareerApplicationStatus =
  | 'planned'
  | 'applied'
  | 'interview'
  | 'offer'
  | 'rejected'
  | 'hired';

export const APPLICATION_STATUSES: CareerApplicationStatus[] = [
  'planned',
  'applied',
  'interview',
  'offer',
  'rejected',
  'hired',
];

export interface ICareerApplication {
  id: string;
  vacancyId: string;
  companyName: string;
  position: string;
  applyUrl: string;
  status: CareerApplicationStatus;
  appliedAt: string;
  nextActionAt: string;
  note: string;
  /**
   * `import` — строка перенесена из старых самоотметок, а не заведена руками.
   * Показывается подписью: выдать импорт за собственную запись человека —
   * то же тихое враньё, что схлопнутый бейдж.
   */
  source: string;
  isPlacementConfirmed: boolean;
  updatedAt: string;
}

export const transformCareerApplications = (
  data?: CareerApplicationsListQuery,
): ICareerApplication[] =>
  (data?.myCareerApplications ?? []).map((row) => ({
    id: row.id,
    vacancyId: row.vacancyId ?? '',
    companyName: row.companyName,
    position: row.position,
    applyUrl: row.applyUrl,
    status: row.status as CareerApplicationStatus,
    appliedAt: row.appliedAt ?? '',
    nextActionAt: row.nextActionAt ?? '',
    note: row.note,
    source: row.source,
    isPlacementConfirmed: row.isPlacementConfirmed,
    updatedAt: row.updatedAt,
  }));
